import Model from 'src/app/common/model';
import BusinessEntity from './businessEntity.model';

export default class Vendors extends Model {
  business: Array<BusinessEntity>;
  name: string;
  site: string;
  city: string;
  state: string;
  contact: string;
  GST_No: string;
  postal_code: string;
  business_id: string;
  comment: string;
  farm_site_id: string;

  constructor() {
    super();
  }
}
